export var ComboboxActionType;
(function (ComboboxActionType) {
    ComboboxActionType["BACKSPACE_SELECTED_OPTION"] = "BACKSPACE_SELECTED_OPTION";
    ComboboxActionType["BLUR"] = "BLUR";
    ComboboxActionType["CHANGE_CURRENT_SELECTED_OPTION"] = "CHANGE_CURRENT_SELECTED_OPTION";
    ComboboxActionType["COLLAPSE"] = "COLLAPSE";
    ComboboxActionType["DELETE_SELECTED_OPTION"] = "DELETE_SELECTED_OPTION";
    ComboboxActionType["ENTER_KEY_PRESS"] = "ENTER_KEY_PRESS";
    ComboboxActionType["EXPAND"] = "EXPAND";
    ComboboxActionType["FOCUS"] = "FOCUS";
    ComboboxActionType["OPTIONS_DOWN"] = "OPTIONS_DOWN";
    ComboboxActionType["OPTIONS_UP"] = "OPTIONS_UP";
    ComboboxActionType["OPTION_MOUSE_CLICK"] = "OPTION_MOUSE_CLICK";
    ComboboxActionType["SEARCH"] = "SEARCH";
    ComboboxActionType["SELECTED_OPTIONS_LEFT"] = "SELECTED_OPTIONS_LEFT";
    ComboboxActionType["SELECTED_OPTIONS_RIGHT"] = "SELECTED_OPTIONS_RIGHT";
    ComboboxActionType["SET_OPTIONS"] = "SET_OPTIONS";
    ComboboxActionType["SET_VALUE"] = "SET_VALUE";
})(ComboboxActionType || (ComboboxActionType = {}));
export const COMBOBOX_FOCUS_GUARD_MS = 300;
export const MAX_LIST_HEIGHTS = {
    m: 'm',
};
// Must match the max-height in ComboboxList.module.css (.ListSizeM:popover-open).
export const MAX_LIST_HEIGHT_PX = {
    m: 192, // var(--ds-48x)
};
export const CONTENT_OFFSET = 4;
